import { render, staticRenderFns } from "./InstructionsDetailedForList.vue?vue&type=template&id=657e407a&"
import script from "./InstructionsDetailedForList.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailedForList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports